<template>
  <article class="search-widget__container">
    <div class="search-widget__title">{{ searchWidgetProps.moduleTitle }}</div>

    <button
      class="search-widget__search-type-selected unstyled-btn"
      tabindex="0"
      ref="searchOptionsDropDown"
      @click="searchOptionsClicked"
      @keypress.enter="searchOptionsClicked"
    >
      {{ getCurrentSearchOption?.label }}
      <div
        :class="{
          'search-widget__search-type-icon': true,
          collapsed: !isSearchOptionsVisible,
        }"
      />
    </button>

    <FormKit
      type="button"
      name="findmycar"
      outer-class="search-widget__search-button-wrapper"
      input-class="btn btn-primary search-widget__search-button"
      @click="toggleMakeModelModal"
    >
      {{ searchWidgetProps.searchButtonText }}
    </FormKit>

    <div class="search-widget__search-type-wrapper">
      <div class="search-widget__search-type-container" v-show="isSearchOptionsVisible">
        <button
          :class="[
            'unstyled-btn',
            {
              'search-widget__search-type': true,
              'search-widget__search-type-highlight': highlightItem(item),
            },
          ]"
          v-for="item in searchWidgetProps.searchOptions"
          :key="item.value"
          @click="searchOptionItemClicked(item, $event)"
          @keypress.enter="searchOptionItemClicked(item, $event)"
          v-text="item.label"
        />
      </div>
    </div>
  </article>
  <MakeModelModal @close-modal="toggleMakeModelModal" v-if="isMakeModelModalVisible" :modal-to-display-on-load="modalToDisplayOnLoad" />
</template>

<script>
import MakeModelModal from '../modals/MakeModelModal.vue';
import { useContentStore } from '../../foundation/stores/contentStore';
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { AnalyticsEvents, AnalyticsEventTypes } from '../../foundation/enums/AnalyticsEvents';

export default {
  name: 'SearchWidget',
  components: {
    MakeModelModal,
  },
  setup() {
    const route = useRoute();
    const routeQuery = route.query;
    const contentStore = useContentStore();
    const { searchWidgetProps } = storeToRefs(contentStore);
    contentStore.fetchSearchWidgetProps();

    const searchOptionsDropDown = ref(null);
    const isSearchOptionsVisible = ref(false);
    const currentSearchOption = ref(null);
    const isMakeModelModalVisible = ref(false);
    const modalToDisplayOnLoad = ref(null);
    const loading = ref(true);
    const error = ref(false);
    const result = ref(null);

    onClickOutside(searchOptionsDropDown, (event) => (isSearchOptionsVisible.value = false));

    return {
      isMakeModelModalVisible,
      isSearchOptionsVisible,
      searchOptionsDropDown,
      modalToDisplayOnLoad,
      currentSearchOption,
      searchWidgetProps,
      routeQuery,
      loading,
      result,
      error,
    };
  },

  props: { datasourceId: String },

  mounted() {
    if (this.routeQuery.searchModalOpen) {
      this.isMakeModelModalVisible = true;
    }
  },

  computed: {
    makeModelFields() {
      return this.fields.MakeModelModal;
    },
    defaultSearchOption() {
      return this.searchWidgetProps.searchOptions.find((opt) => opt.default);
    },
    getCurrentSearchOption() {
      return this.currentSearchOption ?? this.defaultSearchOption;
    },
  },

  methods: {
    searchOptionsClicked() {
      this.isSearchOptionsVisible = !this.isSearchOptionsVisible;
    },
    searchOptionItemClicked(searchOption) {
      this.currentSearchOption = searchOption;
      this.isSearchOptionsVisible = false;
    },
    pushToAnalytics(currentSearchOption) {
      try {
        this.$analytics().push(AnalyticsEvents.NavigationClickToWidget, {
          eventInfo: {
            navigation: { name: `${this.searchWidgetProps.moduleTitle} ${this.getCurrentSearchOption?.label}`, type: AnalyticsEventTypes.CarSearchWidget },
          },
        });
      } catch (error) {
        console.warn('fail to push data to analytics', error);
      }
    },
    toggleMakeModelModal() {
      const currentSearchOption = this.currentSearchOption?.value || '';
      if (!this.isMakeModelModalVisible) this.pushToAnalytics(currentSearchOption);
      switch (currentSearchOption.toLowerCase()) {
        case 'bodytype':
          this.modalToDisplayOnLoad = 'body-type-modal';
          break;
        case 'lifestyle':
          this.modalToDisplayOnLoad = 'lifestyle-modal';
          break;
        default:
          this.modalToDisplayOnLoad = null;
          break;
      }

      this.isMakeModelModalVisible = !this.isMakeModelModalVisible;
    },
    highlightItem(searchOption) {
      return searchOption.value === this.currentSearchOption?.value || '';
    },
  },
};
</script>
<style src="@/assets/css/components/search-widget.scss" lang="scss"></style>
